// counter.ts
import * as app from '../actions/app.actions';
import { App } from '../models/app.model';

export interface State {
  isLoading: boolean;
  currentFilter: string;
  currentPage: string;
  contact: {
    sending: boolean;
    error: boolean;
    sent: boolean;
  }
}

export const initialState: App = {
  isLoading: false,
  currentFilter: null,
  currentPage: null,
  contact:{
    sending: false,
    error: false,
    sent: false
  }
};

export function reducer(state: State = initialState, action: app.Actions): State {

  switch (action.type) {

    case app.FETCH:
      return state;

    case app.SET_PAGE:
      return Object.assign(state, { currentPage:  action.payload });

    case app.RESET:
      return Object.assign({}, initialState);

    case app.SEND_CONTACT_MESSAGE:
      return Object.assign({}, state, { contact:  { sending: true, sent: false, error: false} });

    case app.SEND_CONTACT_MESSAGE_SUCCESS:
      return Object.assign({}, state, { contact:  { sending: false, sent: true, error: false} })

    case app.SEND_CONTACT_MESSAGE_FAILURE:
      return Object.assign({}, state, { contact:  { sending: false, sent: true, error: true} })

    default:
      return state;
  }
}

export const getApp = (state: State) => state;

export const getContactState = (state: State) => state.contact;



// WEBPACK FOOTER //
// ./src/reducers/app.reducer.ts